import React, { useState } from 'react';
import './contact.css';
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaCheckCircle, FaTools, FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import aboutContent from '../../content/pages/about.json';
import faqContent from '../../content/pages/faq.json';
import FaqList from '../../components/faq/FaqList';

// Questions from the FAQ page that are most relevant before getting in touch.
const CONTACT_FAQ_QUESTIONS = [
    'Vad kostar en balpress?',
    'Kan vi hyra en balpress eller komprimator i stället för att köpa?',
    'Vad ingår när vi köper en maskin?',
    'Servar ni maskiner av andra märken?',
];

const toTel = (number) => `tel:${number.replace(/\s/g, '').replace(/^0/, '+46')}`;

const Contact = () => {
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        const form = e.target;
        const data = new FormData(form);

        fetch('/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(data).toString()
        })
        .then(() => setIsSubmitted(true))
        .catch((error) => alert(error));
    };

    const allFaqItems = faqContent.sections.flatMap((section) => section.items);
    const contactFaq = CONTACT_FAQ_QUESTIONS
        .map((question) => allFaqItems.find((item) => item.question === question))
        .filter(Boolean);

    return (
        <>
            <Helmet>
                <title>Kontakt | Cycle Solutions | Offert &amp; support</title>
                <meta
                    name="description"
                    content="Kontakta Cycle Solutions för offert, service eller frågor om komprimatorer och balpressar. Ring, mejla eller fyll i formuläret så hjälper vi dig."
                />
                <link
                    rel="canonical"
                    href="https://cyclesolutions.se/kontakt"
                />
            </Helmet>

            <div className="contact-container">
                <section className="contact-main">
                    <div className="contact-details">
                        <h1>Kontakt</h1>
                        <p className="contact-intro">Har du frågor eller funderingar? Tveka inte på att kontakta oss.</p>

                        <a href={toTel('0645 10 057')} className="contact-phone-main">
                            <FaPhoneAlt />
                            <span>
                                <span className="contact-label">Telefon</span>
                                <span className="contact-phone-number">0645 10 057</span>
                            </span>
                        </a>

                        <ul className="contact-list">
                            <li>
                                <FaTools />
                                <span>För service: <a href={toTel('0645 10 077')}>0645 10 077</a></span>
                            </li>
                            <li>
                                <FaEnvelope />
                                <a href="mailto:Vilhelm@cyclesolutions.se">Vilhelm@cyclesolutions.se</a>
                            </li>
                            <li>
                                <FaMapMarkerAlt />
                                <span>Magnarpsbyaväg 339, 266 55 Vejbystrand</span>
                            </li>
                        </ul>
                    </div>

                    <div className="contact-form-container">
                        {isSubmitted ? (
                            <div className="confirmation-message">
                                <FaCheckCircle size={50} color="#4caf50" />
                                <h3>Tack för ditt meddelande!</h3>
                                <p>Vi återkommer till dig så snart som möjligt.</p>
                                <Link to="/" className="back-home-link">Tillbaka till startsidan</Link>
                            </div>
                        ) : (
                            <form
                                name="contact"
                                method="post"
                                onSubmit={handleSubmit}
                                className="contact-form"
                            >
                                <input type="hidden" name="form-name" value="contact" />
                                <div className="form-group">
                                    <label htmlFor="namn">Namn</label>
                                    <input type="text" id="namn" name="namn" required className="form-control" />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="epost">Epost</label>
                                    <input type="email" id="epost" name="epost" required className="form-control" />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="företag">Företag</label>
                                    <input type="text" id="företag" name="företag" required className="form-control" />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="meddelande">Meddelande</label>
                                    <textarea id="meddelande" name="meddelande" required className="form-control"></textarea>
                                </div>
                                <button type="submit" className="submit-button">Skicka meddelande</button>
                            </form>
                        )}
                    </div>
                </section>

                <section className="contact-people">
                    <h2>Kontaktpersoner</h2>
                    <p>Vill du hellre prata direkt med någon av oss? Här hittar du rätt person.</p>
                    <div className="contact-people-grid">
                        {aboutContent.employees.map((person) => (
                            <div className="contact-person" key={person.email}>
                                <h3>{person.name}</h3>
                                <span className="contact-person-role">{person.role}</span>
                                <a href={toTel(person.phoneNumber)}><FaPhoneAlt /> {person.phoneNumber}</a>
                                <a href={`mailto:${person.email}`}><FaEnvelope /> {person.email}</a>
                            </div>
                        ))}
                    </div>
                </section>

                {contactFaq.length > 0 && (
                    <section className="contact-faq">
                        <h2>Bra att veta innan du hör av dig</h2>
                        <FaqList items={contactFaq} />
                        <Link to="/vanliga-fragor" className="contact-faq-link">
                            Se alla vanliga frågor <FaArrowRight />
                        </Link>
                    </section>
                )}
            </div>
        </>
    );
};

export default Contact;
